import { ModalWrapper } from './components/Modal'
export default ModalWrapper
